import { icon } from '@/shared/content/icons';
import styles from './ls-action.module.scss';

interface Props {
  label: string;
  disabled?: boolean;
  className?: string;
  onClick: () => void;
}

export function LsAction({ label, disabled, className = '', onClick }: Props) {
  return (
    <div className={[styles['ls-action'], className].join(' ')}>
      <button
        className={styles['ls-action__label']}
        type="button"
        disabled={disabled}
        onClick={onClick}
      >
        {label}
      </button>

      <button
        className={styles['ls-action__arrow']}
        type="button"
        disabled={disabled}
        onClick={onClick}
        aria-label={label}
      >
        <img className={styles['ls-action__icon']} src={icon('arrow')} alt="" />
      </button>
    </div>
  );
}
